import IconButton from '@/global/components/Button/IconButton'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from '@/global/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'
import { CircularProgress } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { StoredNotification, useNotificacoesSilentStore } from './store'

interface IProps {
    className?: string
}

export default function ProgressoBackground({ className }: IProps) {
    const [open, setOpen] = useState(false)
    const lastUpdate = useRef(Date.now())
    const state = useNotificacoesSilentStore(state =>
        state.content.filter(
            n => ['pdf', 'progresso'].includes(n.type) && n.value,
        ),
    )

    const progressValue = state.at(-1)?.value || null

    useEffect(() => {
        lastUpdate.current = Date.now()
    }, [progressValue])

    useEffect(() => {
        if (typeof progressValue !== 'number') return setOpen(false)
        const interval = setInterval(() => {
            if (progressValue && Date.now() - lastUpdate.current > 5000) {
                useNotificacoesSilentStore.setState({ content: [] })
            }
        }, 5000)
        return () => clearInterval(interval)
    }, [progressValue])

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger>
                <IconButton
                    component={'div'}
                    className={cn(
                        'transition-opacity duration-300',
                        {
                            'pointer-events-none opacity-0':
                                typeof progressValue !== 'number',
                        },
                        className,
                    )}
                >
                    <Progress value={progressValue || 100} size={16} />
                </IconButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <div className="flex flex-col w-xs max-w-[calc(100vw-2rem)] max-h-80">
                    {state.map((notification, index) => (
                        <DivProgresso key={index} notification={notification} />
                    ))}
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

interface IPropsDiv {
    notification: StoredNotification
}

function DivProgresso({ notification }: IPropsDiv) {
    switch (notification.type) {
        case 'pdf':
            return (
                <div className="flex flex-row items-center gap-2 p-2">
                    <Progress value={notification.value} size={18} />
                    <span>
                        Progresso do PDF {notification.ref}:{' '}
                        {String(notification.value)}%
                    </span>
                </div>
            )
        case 'progresso':
            return (
                <div className="flex flex-row items-center gap-2 p-2">
                    <Progress value={notification.value} size={18} />
                    <span>
                        Progresso do(a) {notification.ref}:{' '}
                        {String(notification.value)}%
                    </span>
                </div>
            )
        default:
            return null
    }
}

interface IProgressoProps {
    value: number
    size: number
}

function Progress({ value, size }: IProgressoProps) {
    return (
        <CircularProgress
            size={size}
            thickness={8}
            variant="determinate"
            value={value}
            className="text-primary-foreground bg-foreground/20 rounded-full ring-3 ring-foreground/20"
        />
    )
}
